import React from 'react';
export function ValidationBar() {
  return <div className="w-full bg-[#5C6B60] py-3 px-4" data-id="element-177">
      <p className="text-center text-sm font-medium text-[#F5F1EA] leading-snug" data-id="element-178">
        Más de 2.400 familias ya activaron la lectura en casa 💛
      </p>
    </div>;
}